import { createSlice } from '@reduxjs/toolkit';
import { DynamoConnector } from '../../DynamoConnector';
import { setAppRoute } from './appSlice';

export const deckSlice = createSlice({
    name: 'deck',
    initialState: {
        deck: null,
        isFetching: false,
        cards: {},
        cache: {},
    },
    reducers: {
        setDeck: (state, action) => {
            state.deck = {
                ...action.payload,
                interactionRating: action?.payload?.details?.powerLevel?.scoring?.interaction?.score,
            };
            state.isShowing = true;
            state.isFetching = false;

            state.cards = {};

            if (Object.keys(state?.deck?.cards || {}).length > 0) {
                state.cards = state.deck.cards;
            }

            if (!state.cache.hasOwnProperty(action.payload.id)) {
                state.cache[action.payload.id] = action.payload;
            }
        },
        setFetchingTrue: (state) => {
            state.isFetching = true;
            state.deck = null;
        },
    },
});

// Actions
export const { setDeck, setFetchingTrue } = deckSlice.actions;

export const fetchDeck = (id) => (dispatch) => {
    dispatch(setFetchingTrue());

    DynamoConnector.getDeck(id, (results) => {
        if (results) {
            dispatch(setDeck(results));
        } else {
            dispatch(setAppRoute({ route: '/' }));
        }
    });
};

export default deckSlice.reducer;
